/**
 * FAQ Accordion
 *
 * Toggles the faq-accordion__item--open class on accordion items and updates
 * aria-expanded on the trigger button. Only one item is open at a time.
 * Uses event delegation on each .faq-accordion__list element.
 *
 * On page load, checks the URL hash. If it matches an accordion item's id
 * (e.g. #faq-what-is-bail), that item is opened and scrolled into view.
 */

document.addEventListener('DOMContentLoaded', function () {

  /**
   * Open a single accordion item and update aria-expanded on its trigger.
   */
  function openItem(item) {
    item.classList.add('faq-accordion__item--open');
    var trigger = item.querySelector('[data-faq-trigger]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  /**
   * Close a single accordion item.
   */
  function closeItem(item) {
    item.classList.remove('faq-accordion__item--open');
    var trigger = item.querySelector('[data-faq-trigger]');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  }

  // -------------------------------------------------------------------------
  // Click handler — event delegation per list.
  // -------------------------------------------------------------------------

  document.querySelectorAll('.faq-accordion__list').forEach(function (list) {

    list.addEventListener('click', function (e) {

      var trigger = e.target.closest('[data-faq-trigger]');
      if (!trigger) return;

      var item   = trigger.closest('[data-faq-item]');
      var isOpen = item.classList.contains('faq-accordion__item--open');

      // Close all open items within this list.
      list.querySelectorAll('.faq-accordion__item--open').forEach(function (openItem) {
        closeItem(openItem);
      });

      // Open clicked item if it was closed.
      if (!isOpen) {
        openItem(item);
      }

    });

  });

  // -------------------------------------------------------------------------
  // Hash-based auto-open on page load.
  // If the URL contains a hash matching an accordion item id, open it and
  // scroll to it after the transition completes.
  // Uses GSAP ScrollSmoother.scrollTo() when available to prevent the
  // jump-then-snap conflict caused by native scrollIntoView fighting the
  // smoother. Falls back to scrollIntoView on non-smoother pages.
  // -------------------------------------------------------------------------

  var hash = window.location.hash; // e.g. "#faq-what-is-bail"
  if (!hash) return;

  var target = document.querySelector('[data-faq-item]' + hash);
  if (!target) return;

  // Open the matched item immediately so the CSS transition starts.
  openItem(target);

  // Wait for:
  //   - accordion transition to complete (400ms in CSS)
  //   - ScrollSmoother to finish initialising (polls at 50ms increments)
  // Then scroll via ScrollSmoother if available; native fallback otherwise.
  setTimeout(function () {
    if (window.scrollSmoother) {
      // Refresh ScrollTrigger so it knows about the new page height
      // after the accordion opened, then scroll using the smoother.
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
      window.scrollSmoother.scrollTo(target, true, 'top 80px');
    } else {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 600);

});
